import { ApiBulkTicket } from "apps/myExperience/modules/bulkTicketManagement/types";
import React from "react";
import Button from "shared/components/button";
import { useCopies } from "shared/hooks/useCopies";
import { getBulkTicketsInfo } from "apps/myExperience/modules/bulkTicketManagement/utils";
import BulletList from "shared/components/bulletList";
import { BulletListSeparator } from "shared/components/bulletList/enum";
import Variant from "shared/enums/Variant";

export function BulkTicketsPurchasedDashboard(props: { bulkTicketsList: ApiBulkTicket[]; handleAssign: Function }) {
  const copies = useCopies();
  const bulkTicketsInfo = React.useMemo(() => {
    return getBulkTicketsInfo(props.bulkTicketsList);
  }, [props.bulkTicketsList]);

  if (!bulkTicketsInfo.hasAnyPurchases) {
    return null;
  }

  return (
    <div className="blkTktDashboard">
      <div className="blkTktDashboard_ticketTypeWapper">
        <div className="blkTktDashboard_ticketTypeHeader">
          {bulkTicketsInfo.hasAnyPurchases && (
            <h6 className="blkTktDashboard_ticketTypeHeader--text">{copies.get("purchases")}</h6>
          )}
        </div>
        <div className="blkTktDashboard_ticketTypeList">
          {Object.keys(bulkTicketsInfo.purchasesByFormType).map((key, index) => {
            if (bulkTicketsInfo.purchaseStatsByFormType[key].ticketsPurchased === 0) {
              return null;
            }
            return (
              <div className="blkTktDashboard_ticketTypeListCard" key={key}>
                <div className="blkTktDashboard_ticketTypeListCard--left">
                  <h4 className="blkTktDashboard_ticketTypeListCard--leftTitle">{key}</h4>
                </div>
                <div className="blkTktDashboard_ticketTypeListCard--right">
                  <BulletList separator={BulletListSeparator.DOT}>
                    <BulletList.Item
                      text={
                        <div className="blkTktDashboard_ticketTypeListCard--rightCounts">
                          {bulkTicketsInfo.purchaseStatsByFormType[key].unAssignedTickets === 0 ? (
                            <span>{copies.get("all.assigned")}</span>
                          ) : (
                            <React.Fragment>
                              <span className="btUnassigned">
                                {bulkTicketsInfo.purchaseStatsByFormType[key].unAssignedTickets}
                              </span>
                              {copies.get("of")}
                              <span className="btTotal">
                                {" "}
                                {bulkTicketsInfo.purchaseStatsByFormType[key].ticketsPurchased}
                              </span>
                              {copies.get("unassigned")}
                            </React.Fragment>
                          )}
                        </div>
                      }
                    />
                    {bulkTicketsInfo.purchaseStatsByFormType[key].unAssignedTicketFormIdList.length > 0 && (
                      <BulletList.Item
                        className="blkTktDashboard_ticketTypeListCard--rightAction"
                        text={
                          <Button.Create
                            label={copies.get("assign")}
                            variant={Variant.LINK}
                            onClick={() => {
                              props.handleAssign(
                                bulkTicketsInfo.purchaseStatsByFormType[key].unAssignedTicketFormIdList[0]
                              );
                            }}
                          />
                        }
                      />
                    )}
                  </BulletList>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
